export default "__VITE_ASSET__35a18967__"